import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../services/firebase";
import { COLLECTIONS } from "../../../../services/collections";

export const useCashierBanks = (idTenant) => {
    const [bankAccounts, setBankAccounts] = useState([]);
    const [loadingBanks, setLoadingBanks] = useState(false);

    useEffect(() => {
        if (!idTenant) return;

        let isMounted = true;
        const fetchAccounts = async () => {
            setLoadingBanks(true);
            try {
                const snap = await getDocs(
                    collection(db, "tenants", idTenant, COLLECTIONS.BANK_ACCOUNTS)
                );

                if (!isMounted) return;

                const accounts = [];
                snap.forEach(doc => {
                    accounts.push({ id: doc.id, ...doc.data() });
                });
                setBankAccounts(accounts);
            } catch (err) {
                console.error("[useCashierBanks] Erro carregando contas bancárias:", err);
            } finally {
                if (isMounted) setLoadingBanks(false);
            }
        };

        fetchAccounts();
        return () => { isMounted = false; };
    }, [idTenant]);

    return { bankAccounts, loadingBanks };
};
